import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { SectionHeader } from '@/components/home/CoreSections';
import { homeT } from '@/i18n/homeI18n';
import { arHref } from '@/i18n/navData';

const BRANDS = [
  { id: 'europcar', label: 'Europcar', href: '/europcar', logo: '/brands/europcar.png' },
  { id: 'goldcar', label: 'Goldcar', href: '/goldcar', logo: '/brands/goldcar.png' },
  { id: 'chauffeur', label: 'Eurogulf Chauffeur Service', href: '/chauffeur-service', logo: '/brands/chauffeur-egmg.webp' },
  { id: 'emirates-taxi', label: 'Emirates Taxi', href: '/emirates-taxi', logo: '/brands/emirates-taxi-egmg.webp' },
  { id: 'royal-limo', label: 'Royal Limousine Coach', href: '/royal-limousine', logo: '/brands/royal-limo-egmg.webp' },
  { id: 'truckline', label: 'Truck Line Transport', href: '/truckline', logo: '/brands/truckline-egmg.webp' },
  { id: 'used-cars', label: 'Eurogulf Used Car', href: '/used-cars', logo: '/brands/used-cars-egmg.webp' },
];

function BrandLogos({ label, isAr }) {
  return (
    <div id="our-brands" data-testid="brand-logo-strip" className="mt-14 lg:mt-16">
      <p className="font-heading font-bold text-[11px] tracking-[0.25em] uppercase text-[#666666]">{label}</p>
      <div className="mt-5 flex flex-wrap border-s border-t border-black/[0.06]">
        {BRANDS.map((b) => (
          <Link key={b.id} to={isAr ? arHref(b.href) : b.href} data-testid={`brand-logo-${b.id}`} aria-label={b.label} className="group flex h-24 w-1/2 items-center justify-center border-e border-b border-black/[0.06] bg-white px-5 transition-colors duration-300 hover:bg-[#FFF4ED] sm:w-1/4 lg:w-[14.2857%]">
            <img src={b.logo} alt={b.label} loading="lazy" className="max-h-12 w-auto max-w-full object-contain transition-transform duration-300 group-hover:scale-105" />
          </Link>
        ))}
      </div>
    </div>
  );
}

function FiftyYears({ t }) {
  return (
    <div data-testid="group-intro-50" className="lg:col-span-5 lg:justify-self-end">
      <div className="flex items-end gap-4">
        <span className="font-heading font-black text-[112px] sm:text-[140px] lg:text-[160px] leading-[0.82] tracking-[-0.05em] text-[#EE5A01]">{t.big}</span>
        <div className="pb-2 sm:pb-3">
          <p className="font-heading font-bold text-lg sm:text-xl text-[#121212] leading-tight">{t.line1}<br />{t.line2}</p>
          <p className="mt-2 font-heading font-bold text-[11px] tracking-[0.25em] uppercase text-[#666666]">{t.range}</p>
        </div>
      </div>
      <p className="mt-5 max-w-sm font-body text-sm text-[#666666] leading-relaxed">{t.fiftyDesc}</p>
    </div>
  );
}

export function GroupIntro({ lang = 'en' }) {
  const t = homeT(lang).intro;
  return (
    <section data-testid="group-intro" className="bg-white py-16 sm:py-20 lg:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-end">
          <div className="lg:col-span-7">
            <SectionHeader compact chip={t.chip} title={t.title} desc={t.desc} />
            <div className="mt-8 flex flex-wrap items-center gap-5">
              <Link to={t.ctaHref} data-testid="group-intro-cta" className="btn-primary">{t.cta} <ArrowRight className="w-4 h-4 rtl:rotate-180" /></Link>
              <Link to={t.solutionsHref} data-testid="group-intro-solutions" className="inline-flex items-center gap-1 font-heading font-bold text-sm text-[#121212] hover:text-[#EE5A01] hover:gap-2 transition-all">{t.solutions} <ArrowRight className="w-4 h-4 rtl:rotate-180" /></Link>
            </div>
          </div>
          <FiftyYears t={t} />
        </div>
        <BrandLogos label={t.brandsLabel} isAr={lang === 'ar'} />
      </div>
    </section>
  );
}
